'use client'

import { setFooterTab } from '@/redux/features/filterSlice'
import { FooterBranch, useGetAllBranchesQuery, useGetAllProductionsQuery } from '@/redux/services/footerApi'
import s from '../../features/testing/ui/MainModulev1/ui/MainModulev1.module.scss'
import { RootState } from '@/redux/store'
import cn from 'classnames'
import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ForPartners from '../ForPartners/ForPartners'
import FooterBottom from './FooterBottom'
import FooterContacts from './FooterContacts'
import { MapTheme } from './Map'
import { useTranslation } from 'react-i18next'
import { YMapsProvider } from '@/providers/YMapsProvider'
import dynamic from 'next/dynamic'
const Map = dynamic(() => import('./Map'), {
    loading: () => <p>Loading...</p>
})
const FooterProduction = dynamic(() => import('./FooterProduction'), {
    loading: () => <p>Loading...</p>
})

interface IProps {
    mapTheme?: MapTheme
}

const productions = [
    {
        id: 1,
        title: 'Москва (Новофедоровское)',
        desc: 'МЕГАМИКС КОМБИКОРМ',
        address: 'Москва, 108805, пос. Новофедоровское, д. Кузнецово, а/д "Украина", 60 км',
        email: 'mmk@megamix.ru',
        phone: '+7 (495) 122-23-70',
        link: 'https://yandex.ru/maps/geo/derevnya_kuznetsovo/53063453/?ll=36.955909%2C55.448586&z=14.13',
        city: 'Москва',
        coors: '55.456449, 36.938257'
    },
    {
        id: 2,
        title: 'МЕГАМИКС',
        desc: 'производство',
        address: 'Волгоград, 400123, ул. Хрустальная, 107, оф.1',
        email: 'info@megamix.ru',
        phone: '+7 (8442) 97-97-97',
        link: 'https://yandex.ru/maps/38/volgograd/house/khrustalnaya_ulitsa_107/YE0YcwRkTkUPQFpifXt4cnRgZQ==/?ll=44.534708%2C48.793832&z=17',
        city: 'Волгоград',
        coors: '48.793831, 44.534708'
    },
    {
        id: 3,
        title: 'МЕГАМИКС ЦЕНТР',
        desc: 'производство',
        address: 'Липецкая область, 399540, с. Тербуны, ул. Дорожная, 5г',
        email: 'abdullaeva.v@megamix.ru',
        phone: '+7 (8442) 97-97-97 доб.432',
        link: 'https://yandex.ru/maps/10712/lipetsk-oblast/house/dorozhnaya_ulitsa_5g/Z0EYdABjT0EPQFtofX1zcnllZQ==/?ll=38.273648%2C52.123561&z=17',
        city: 'Липецк',
        coors: '52.123561, 38.273648'
    }
]

const Footer: React.FC<IProps> = ({ mapTheme }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { footerTab } = useSelector((state: RootState) => state.filter)

    const { data: branches = [] } = useGetAllBranchesQuery()

    const [selectedChapters, setSelectedChapters] = useState<number>(null)
    const [selectedChaptersProd, setSelectedChaptersProd] = useState<number>(null)

    const linksArray = useMemo(() => [t('productions'), t('office'), t('Feedback')], [])

    const handleBranchesDropdownToggle = useCallback(
        (id: number) => () => {
            const isSelected = selectedChapters === id

            if (isSelected) {
                setSelectedChapters(null)
                return
            }
            setSelectedChapters(id)
        },
        [selectedChapters]
    )

    const handleBranchesDropdownToggleProd = useCallback(
        (id: number) => () => {
            const isSelected = selectedChaptersProd === id

            if (isSelected) {
                setSelectedChaptersProd(null)
                return
            }
            setSelectedChaptersProd(id)
        },
        [selectedChaptersProd]
    )

    const isMiddleTabsActive = useMemo(() => footerTab === 1 || footerTab === 2, [])

    return (
        <>
            <div
                className='container'
                style={{ marginTop: '132px', marginBottom: '132px' }}
            >
                <h3 className={s.section_header}>{t('contacts')}</h3>
                <FooterContacts />
            </div>
            <footer
                className={cn('footer footer__grid')}
                id={'contact'}
                style={{ paddingTop: isMiddleTabsActive ? 133 : 85 }}
            >
                {isMiddleTabsActive ? (
                    <YMapsProvider>
                        <Map
                            theme={mapTheme}
                            branches={footerTab === 2 ? branches : productions}
                            onDropdownToggle={handleBranchesDropdownToggle}
                        />
                    </YMapsProvider>
                ) : null}
                <ul className='footer__links'>
                    {linksArray?.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => dispatch(setFooterTab(index))}
                            className={`footer__links-item ${footerTab === index && 'footer__links-item_active'}`}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
                <div
                    style={{ maxWidth: isMiddleTabsActive ? 448 : 'none' }}
                    className={`footer__top-wrapper ${footerTab === 1 && 'footer__top-wrapper_overlay'}`}
                >
                    <div
                        style={isMiddleTabsActive ? { height: 662 } : { zIndex: 12 }}
                        className={`footer__top ${isMiddleTabsActive ? 'footer__top_overlay' : ''}`}
                    >
                        <div className='footer__overlay_overlay'></div>{' '}
                        {footerTab === 0 && (
                            <FooterProduction
                                branches={productions}
                                selectedChapters={selectedChaptersProd}
                                onDropdownToggle={handleBranchesDropdownToggleProd}
                            />
                        )}
                        {footerTab === 1 && (
                            <FooterProduction
                                branches={branches}
                                selectedChapters={selectedChapters}
                                onDropdownToggle={handleBranchesDropdownToggle}
                            />
                        )}
                        {footerTab === 2 && <ForPartners title={false} />}
                    </div>
                </div>
                <FooterBottom />

                {isMiddleTabsActive ? (
                    <div className={`footer__shadow ${mapTheme == 'light' ? 'footer__shadow-white' : ''}`} />
                ) : null}
            </footer>
        </>
    )
}

export default Footer
